// extracted by mini-css-extract-plugin
export var successStory = "style-module--success-story--7d699";
export var successStory__image = "style-module--success-story__image--268fe";
export var successStory__link = "style-module--success-story__link--8f768";
export var successStory__text = "style-module--success-story__text--b63f7";